import routeNames from '@/router/names'
import routeViews from '@/router/views'
import * as loaded from '@/hooks/loaded'
import * as failed from '@/hooks/failed'

export default [
  {
    path: '/editor/:profileUid/content/mode',
    name: routeNames.Modes,
    meta: {
      title: 'pb2.pageTitles.mode',
      loaded: loaded.editor,
      failed: failed.editor,
    },
    redirect: (to) => ({
      // Redirect to the first mode
      name: routeNames.Mode,
      params: {
        ...to.params,
        modeUid: to.params.modeUid || to.query.modeUid || 0,
      },
    }),
    components: {
      [routeViews.Header]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileHeader/ProfileHeader.vue'),
      [routeViews.Main]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/ProfileContent.vue'),
    },
    children: [
      {
        path: 'reorder',
        name: routeNames.ManageModes,
        meta: {
          title: 'pb2.pageTitles.manageModes',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ModeProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/ManageModesDialog.vue'),
        },
      },
      {
        path: ':modeUid',
        name: routeNames.Mode,
        meta: {
          title: 'pb2.pageTitles.mode',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        props: {
          [routeViews.MiddlePanel]: { message: 'pb2.panelMessages.selectOrAddChannel' },
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/EmptyPanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ModeProperties.vue'),
        },
      },
      {
        path: ':modeUid/c/add',
        name: routeNames.AddLocalChannel,
        meta: {
          title: 'pb2.pageTitles.addChannels',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/EmptyPanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/AddChannelDialog.vue'),
        },
      },
      {
        path: ':modeUid/c/:channelUid',
        name: routeNames.LocalChannel,
        meta: {
          title: 'pb2.pageTitles.channel',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        redirect: (to) => ({
          // Redirect to the first presetRange
          name: routeNames.LocalPresetRange,
          params: {
            ...to.params,
            presetRangeUid: to.params.presetRangeUid || to.query.presetRangeUid || 0,
          },
        }),
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
        },
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid',
        name: routeNames.LocalPresetRange,
        meta: {
          title: 'pb2.pageTitles.presetRange',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
        },
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid/distribute',
        name: routeNames.DistributeLocalPresets,
        meta: {
          title: 'pb2.pageTitles.distributePresets',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/DistributePresetsDialog.vue'),
        },
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid/p/add',
        name: routeNames.AddLocalPreset,
        redirect: (to) => ({
          name: routeNames.AddLocalPresetTag,
          params: {
            ...to.params,
            tag: ['Recommended'],
          },
          query: to.query,
        }),
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid/p/add/tag/:tag*',
        name: routeNames.AddLocalPresetTag,
        meta: {
          title: 'pb2.pageTitles.addPresets',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/PresetProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/AddPresetDialog.vue'),
        },
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid/p/:presetUid',
        name: routeNames.LocalPreset,
        meta: {
          title: 'pb2.pageTitles.preset',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/PresetProperties.vue'),
        },
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid/p/:presetUid/replace',
        name: routeNames.ReplaceLocalPreset,
        redirect: (to) => ({
          name: routeNames.ReplaceLocalPresetTag,
          params: {
            ...to.params,
            tag: ['Recommended'],
          },
        }),
      },
      {
        path: ':modeUid/c/:channelUid/pr/:presetRangeUid/p/:presetUid/replace/tag/:tag*',
        name: routeNames.ReplaceLocalPresetTag,
        meta: {
          title: 'pb2.pageTitles.replacePreset',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/PresetProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/ReplacePresetDialog.vue'),
        },
      },
    ],
  },
]
